<template>
  <div class="pc-container case-detail-container">
    <my-header :fixed="true" :white="true"></my-header>
    <div class="case-detail-content dwc-detail-content">
      <div class="title">{{ $t("egame.title") }}</div>
      <div class="sub-title">{{ $t("egame.game_plat") }}</div>
      <div class="decorate"></div>
      <div class="main-image"><img src="../../assets/images/dwc_img1.jpg" alt=""></div>
      <div class="title">
        <div class="num">PRESENTATION</div>
        <div class="text">{{ $t("tmall.page_diplay") }}</div>
      </div>
      <div class="main-desc">
        <div class="img-wrapper"><img src="../../assets/images/dwc_img2.jpg" alt=""></div>
        <div class="info">
          <h4>{{ $t("egame.game_plat") }}</h4>
          <p> {{ $t("egame.game_plat_des") }} </p>
          <h4>{{ $t("tmall.cate") }}</h4>
          <p>{{ $t("egame.cate_des") }}</p>
          <h4>{{ $t("tmall.liability") }}</h4>
          <p>{{ $t("egame.liability_des") }}</p>
          <h4>{{ $t("tmall.language") }}</h4>
          <p>{{ $t("tmall.language_des") }}</p>
        </div>
      </div>
      <div class="detail-images"><img src="../../assets/images/dwc_img3.jpg" alt=""></div>
      <div class="other-info">
        <div>
          <p>{{ $t("egame.feture") }}</p>
          <h4>{{ $t("tmall.Problem") }}</h4>
          <p>{{ $t("egame.problem_des") }}</p>
        </div>
        <div>
          <h4>{{ $t("tmall.solution") }}</h4>
          <p> {{ $t("egame.solution_des") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Yuebao',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
